// TODO: move to common component folder; used by guest manager and virtual events

import React, { Suspense } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

// Utils
import importImages from '../../../../util/webpack';
import { formatWeddingDate, formatLocation } from '../util/previewUtils';

// Components
import PublicPagesNav from '../../../PublicWebsite/PublicPagesNav';
import PublicHeader from '../../../PublicWebsite/PublicHeader';
import PublicFooter from '../../../PublicWebsite/PublicFooter';
import * as PAGE_COMPONENTS from './helper';

const previewImages = importImages(
  require.context('../../../../assets/images/icons/', false, /\.(jpg|jpeg|png|gif|svg)(\?.*)?$/)
);

const WebsitePreview = ({
  activePage,
  isHome,
  values,
  pages,
  wedding,
  account,
  weddingValues,
  pageComponentKey,
  eventFormData = null,
  showStickyPreview,
}) => {
  const CurrentPage = activePage ? PAGE_COMPONENTS[pageComponentKey] : null;
  const pageData = Object.assign({}, activePage, values);
  const date = isHome ? weddingValues.date : wedding.wedding_date;
  const weddingDate = formatWeddingDate(date);

  // data that uses live form values
  const formData = {
    title: isHome ? weddingValues.title : wedding.title,
    location: isHome
      ? formatLocation(weddingValues.city, weddingValues.stateProvince)
      : formatLocation(account.city, account.state_province),
    hashtag: isHome ? weddingValues.hashtag : wedding.hashtag,
    weddingDate,
    city: isHome ? weddingValues.city : null,
    stateProvince: isHome ? weddingValues.stateProvince : null,
  };

  const liveNavPages = activePage
    ? pages.map(page => {
        if (page.type !== activePage.type) return page;
        const title = isHome ? values.nav_title : values.title;
        return { ...page, nav_title: title };
      })
    : null;

  return (
    <div
      className={cx('website-preview-v2', {
        'margin-top': !isHome,
      })}
    >
      <div
        className={cx('preview-container', { 'sticky-preview-container': showStickyPreview })}
        id="public-wrapper"
      >
        <div className="chrome-img" />
        {activePage && activePage.hidden && (
          <div id="page-hidden-banner" className="text-center">
            <p>
              <img
                src={previewImages('npHidden').default}
                className="margin-right-2x"
                alt="Not Visible Icon"
              />
              This page is hidden, visible only to you.
            </p>
          </div>
        )}
        <div className="preview-frame-container">
          <div className="preview-frame">
            <div className="sticky-nav">
              {wedding.slug && formData.title && (
                <PublicHeader
                  slug={wedding.slug}
                  name={formData.title}
                  weddingDate={weddingDate}
                  location={formData.location}
                  hashtag={formData.hashtag}
                />
              )}
              {wedding.slug && pages && <PublicPagesNav slug={wedding.slug} pages={liveNavPages} />}
            </div>
            <div id="public-page-content-wrapper">
              <Suspense fallback={null}>
                {CurrentPage && (
                  <CurrentPage forPreview page={pageData} formData={eventFormData || formData} />
                )}
              </Suspense>
              {wedding.owner_first_name &&
                wedding.partner_first_name &&
                activePage &&
                activePage.type !== 'HOME' &&
                account.enable_seal && (
                  <div className="container seal">
                    <div className="seal-section">
                      <span className="name-1">
                        {wedding.owner_first_name && (
                          <span className="initial-1">{wedding.owner_first_name[0]}</span>
                        )}
                        {wedding.owner_last_name && (
                          <span className="initial-2">{wedding.owner_last_name[0]}</span>
                        )}
                      </span>
                      {wedding.owner_first_name && wedding.partner_first_name && (
                        <span>
                          <span className="amp">&amp;</span>
                          <span className="and">and</span>
                          <span className="plus">+</span>
                        </span>
                      )}
                      <span className="name-2">
                        {wedding.partner_first_name && (
                          <span className="initial-1">{wedding.partner_first_name[0]}</span>
                        )}
                        {wedding.partner_last_name && (
                          <span className="initial-2">{wedding.partner_last_name[0]}</span>
                        )}
                      </span>
                    </div>
                  </div>
                )}
            </div>
            {activePage && <PublicFooter page={activePage} />}
          </div>
        </div>
      </div>
    </div>
  );
};

WebsitePreview.propTypes = {
  values: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    hidden: PropTypes.bool,
  }),
  activePage: PropTypes.shape({}),
  pages: PropTypes.arrayOf(PropTypes.shape({})),
  wedding: PropTypes.shape({}),
  account: PropTypes.shape({}),
  isHome: PropTypes.bool,
  weddingValues: PropTypes.shape({}),
  eventForm: PropTypes.shape({}), // only passed down by guest manager WebsitePreviewContainer to reuse component
};

export default WebsitePreview;
